<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('产品描述')" prop="productDesc">
                <a-input v-model="queryParam.productDesc" :maxLength="32" :placeholder="$t('请输入')+$t('产品描述')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('名称')" prop="name">
                <a-input v-model="queryParam.name" :maxLength="32" :placeholder="$t('请输入')+$t('名称')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('状态')" prop="status">
                <a-select v-model="queryParam.status" placeholder="" allow-clear>
                  <a-select-option v-for="(item, index) in this.customDict.CustomRequestStatusEnum" :value="item.type"
                                   :key="index">
                    {{ $t(item.name) }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <table-setting
          style="margin-bottom: 24px;"
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <detail-dialog
        ref="detailDialog"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: '160%', y: tableScrollY }"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="auditTime" slot-scope="text, record">
          {{ parseTime(record.auditTime) }}
        </span>
        <span slot="country" slot-scope="text, record">
          {{ `${record.country}${record.city}` }}
        </span>
        <span slot="status" slot-scope="text, record">
           <custom-dict-tag :options="customDict.CustomRequestStatusEnum" :value="record.status" />
        </span>
        <template slot="productMedia" slot-scope="text, record">
          <div style="width:40px;height:40px;">
            <img
              v-if="record.productMedia && record.productMedia.length > 0"
              :src="record.productMedia[0]"
              style="width:40px;height:40px;"
              @click="handleRecordPreview(record.productMedia[0])"
              alt="none"
            />
          </div>
        </template>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.detailDialog.handleShow(record)" v-hasPermi="['goods:goodscustomrequest:edit']">
            {{ $t('查看详情') }}
          </a>
          <template v-if="record.status === 0">
            <a-divider type="vertical" v-hasPermi="['goods:goodscustomrequest:edit']" />
            <a @click="handleBatchRejectShow(record)" v-hasPermi="['goods:goodscustomrequest:edit']">
              {{ $t('审核拒绝') }}
            </a>
            <a-divider type="vertical" v-hasPermi="['goods:goodscustomrequest:edit']" />
            <a @click="$refs.createForm.handleAdd(record, undefined)"  v-hasPermi="['goods:goodscustomrequest:edit']">
              {{ $t('创建订单') }}
            </a>
          </template>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <reject-modal
      :visible="rejectModalVisible"
      :onReject="handleBatchReject"
      @cancel="rejectModalVisible = false"
    />
  </page-header-wrapper>
</template>

<script>
import { pageGoodsCustomRequest, listGoodsCustomRequest, delGoodsCustomRequest, batchRejectGoodsCustomRequest } from '@/api/goods/goodsCustomRequest'
import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'
import moment from 'moment'
import CreateForm from './modules/CreateForm'
import DetailDialog from './modules/DetailDialog'
import { tableMixin } from '@/store/table-mixin'
import { parseTime } from '@/utils/ruoyi'
import RejectModal from '@/components/RejectModal/index.vue'

export default {
  name: 'GoodsCustomRequest',
  components: {
    RejectModal,
    CustomDictTag,
    CreateForm,
    DetailDialog
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: undefined,
        userId: undefined,
        demand: undefined,
        nameType: undefined,
        name: undefined,
        email: undefined,
        mobile: undefined,
        country: undefined,
        city: undefined,
        status: undefined,
        auditorId: undefined,
        auditorName: undefined,
        auditTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('产品描述') ,
          dataIndex: 'productDesc',
          ellipsis: true,
          align: 'center',
          width: '200px',
          fixed: 'left'
        },
        {
          title: this.$t('数量') ,
          dataIndex: 'quantity',
          align: 'center'
        },
        {
          title: this.$t('产品图片') ,
          dataIndex: 'productMedia',
          align: 'center',
          scopedSlots: { customRender: 'productMedia' }
        },
        {
          title: this.$t('姓名') ,
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('邮箱') ,
          dataIndex: 'email',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('电话号码') ,
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('国家及城市') ,
          dataIndex: 'country',
          ellipsis: true,
          scopedSlots: { customRender: 'country' },
          align: 'center'
        },
        {
          title: this.$t('提交时间') ,
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('状态') ,
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '220px',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right'
        }
      ],
      rejectModalVisible: false,
      rejectId: undefined
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  methods: {
    parseTime,
    moment,
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    /** 查询产品定制申请列表 */
    getList() {
      this.loading = true
      pageGoodsCustomRequest(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        id: undefined,
        userId: undefined,
        demand: undefined,
        nameType: undefined,
        name: undefined,
        email: undefined,
        mobile: undefined,
        country: undefined,
        city: undefined,
        status: undefined,
        auditorId: undefined,
        auditorName: undefined,
        auditTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk() {
          let data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delGoodsCustomRequest(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(
                message,
                3
              )
            })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk() {
          that.download('goods/goods/custom/request/export',
            that.queryParam
            , `产品定制申请_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    },
    handleBatchRejectShow(row) {
      this.rejectId = row.id
      this.rejectModalVisible = true
    },
    handleBatchReject(reason) {
      var that = this
      const data = [this.rejectId]
      return batchRejectGoodsCustomRequest({ ids: data, reason: reason })
        .then(() => {
          that.getList()
          const message = that.$t('拒绝成功')
          that.$message.success(
            message,
            3
          )
          this.rejectId = undefined
          this.rejectModalVisible = false
        }).catch(() => {
          this.rejectId = undefined
          this.rejectModalVisible = false
        })
    }
  }
}
</script>
